import { Download, Upload } from "lucide-react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadSchedule } from "../../lib/schedule-document/download-schedule";
import { loadScheduleText } from "../../lib/schedule-document/load-schedule-text";
import { useScheduleStore } from "../../stores/schedule-store";
import { Button } from "../ui/button";
import { ResetScheduleButton } from "./ResetScheduleButton";

export function ScheduleJsonControls() {
  const { t } = useTranslation();
  const input = useRef<HTMLInputElement>(null);
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exportFailed, setExportFailed] = useState(false);
  const storageFailed = useScheduleStore(state => state.storageFailed);
  const exportJson = () => {
    setExportFailed(false);
    try {
      downloadSchedule();
    } catch {
      setExportFailed(true);
    }
  };
  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex">
        <Button variant="action" size="sm" onClick={exportJson}><Download />{t("schedule.exportJson")}</Button>
        <Button variant="action" size="sm" disabled={loading} onClick={() => input.current?.click()}><Upload />{t("schedule.loadJson")}</Button>
        <ResetScheduleButton disabled={loading} />
        <input ref={input} type="file" accept=".json,application/json" className="hidden" onChange={async event => {
          const file = event.target.files?.[0];
          event.target.value = "";
          if (!file) return;
          setLoading(true);
          setFailed(false);
          try {
            loadScheduleText(await file.text());
          } catch (error) {
            console.error("Failed to parse schedule JSON", error);
            setFailed(true);
          } finally {
            setLoading(false);
          }
        }} />
      </div>
      {failed && <p role="alert" className="text-xs text-red-600">{t("schedule.jsonError")}</p>}
      {exportFailed && <p role="alert" className="text-xs text-red-600">{t("schedule.exportError")}</p>}
      {storageFailed && <p role="alert" className="text-xs text-red-600">{t("schedule.storageError")}</p>}
    </div>
  );
}
